import { MODULE_NAME } from './constants';

export const moduleState = (state) => state[MODULE_NAME] || {};

export const productWidgetList = (state) => moduleState(state).productWidgets?.data || [];

export const countdownWidgets = (state) => moduleState(state).countdownWidgets?.data || [];

export const widgetListProducts = (state) => moduleState(state).productWidgets?.products || [];
